import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import CustomTooltip from "../Tooltip";

const Index = ({ tooltipPlacement, ...other }) => {
  const { t } = useTranslation(["configure"]);

  return (
    <CustomTooltip title={t("Print View")} placement={tooltipPlacement}>
      <Button type="primary" color="primary" style={{ padding: "5px 7px" }} {...other}>
        <FontAwesomeIcon icon={faPrint} style={{ fontSize: "1.4rem" }} />
      </Button>
    </CustomTooltip>
  );
};

export default Index;
